import { useQuery } from 'react-query';
import { apiResourceLinks } from '../../../constants/apiResourceLinks';
import { dotNetAxios, AxiosQueryResponse } from '../../../utils/axios';
import { CashMovementActivityResponse, PaginatedRequest } from '../../../types/request';
import { usePaginationRequestInfo } from '../../../providers/PaginationRequestProvider';
import { FilterKey } from '../../../providers/FiltersProvider';
import { usePaginationRequestInput } from '../../../hooks/usePaginationRequestInput';
import { usePermissions } from '../../../providers/PermissionsProvider';

const getCashMovementRequests = async (request: PaginatedRequest) => {
    const { data }: AxiosQueryResponse = await dotNetAxios.post(
        apiResourceLinks.cashMovementRequestsPagination,
        request
    );
    return data;
};

interface CashMovementRequestsQueryOptions {
    activeFilterName?: FilterKey;
    pageName?: string;
    refetchInterval?: number;
}
export function useCashMovementRequestsQuery({
    activeFilterName,
    pageName,
    refetchInterval = 5000
}: CashMovementRequestsQueryOptions = {}) {
    const { setPaginationInfo } = usePaginationRequestInfo(activeFilterName, pageName);
    const input = usePaginationRequestInput(activeFilterName, pageName);
    const { requestQuery, paginationInfo, sortingInfo } = input;
    const { cashMovementRequestsEnabled, achPullRequestsEnabled } = usePermissions();

    return useQuery<CashMovementActivityResponse>(
        [
            'CashMovementRequests',
            requestQuery,
            paginationInfo?.pageNumber,
            paginationInfo?.pageSize,
            sortingInfo?.sortingBy,
            sortingInfo?.sortDirection
        ],
        () => getCashMovementRequests(input),
        {
            enabled:
                (cashMovementRequestsEnabled || achPullRequestsEnabled) &&
                Boolean(input.sortingInfo && input.paginationInfo && input.requestQuery),
            refetchInterval,
            refetchIntervalInBackground: true,
            refetchOnWindowFocus: true,
            onSuccess: (data) => {
                setPaginationInfo(data.paginationInfo);
                return data;
            }
        }
    );
}
